import React from "react";
import VideoRateControl from "./VideoRateControl";

export default class StreamedianPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bufferDuration: 30,
      socket: "wss://streamedian.com/ws/",            
      redirectNativeMediaErrors: true,
      errorHandler: this.errHandler.bind(this),
    };

    this.player = null;
    this.restart = this.restart.bind(this);
  }

  componentDidMount() {
    this.player = window.Streamedian.player(this.props.id, this.state);
  }

  componentWillUnmount() {
    this.player.destroy();
    this.player = null;
  }

  restart() {
    this.player.player.src = this.state.source;
    this.player.destroy();
    this.player = null;
    this.player = window.Streamedian.player(this.props.id, this.state);
  }

  errHandler(err) {
    console.error(err.message);
  }

  render() {
    return (
      <div>
        <video id={this.props.id} controls autoPlay>
          {this.props.children}
        </video>
        <VideoRateControl video={this.props.id} />
      </div>
    );
  }
}
